import { AppRoute } from "app";
import { ReactNode } from "react";

import Button, { ContactButton, ContactButtonMethod } from "components/Button";
import ClientTranslation from "components/ClientTranslation";
import Flex from "components/Flex";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { useClientTranslation } from "hooks/useClientTranslation";
import { usePageRouting } from "hooks/usePageRouting";
import { usePageTracking } from "hooks/usePageTracking";

import { useStyles } from "./styles";
import { useConfig } from "../../hooks/useConfig";

export const OutOfScope = () => {
  usePageTracking({ name: "Estimate - Out of scope" });

  const { navigateTo } = usePageRouting();
  const { t } = useClientTranslation();
  const { classes } = useStyles();

  const { displayName: client, flowCompletionRedirectUrl, contactButton } = useConfig();

  const generateCTAButton = (): ReactNode => {
    if (flowCompletionRedirectUrl)
      return (
        <Button href={flowCompletionRedirectUrl} rel="noopener noreferrer" component="a">
          {t("global.continue")}
        </Button>
      );

    return <Button onClick={() => navigateTo(AppRoute.FlowCompleted)}>{t("global.continue")}</Button>;
  };

  return (
    <PageLayout title={t("out_of_scope.header")} bottomButtons={generateCTAButton()} dataTestId="outOfScope">
      <Flex px={24} direction="column">
        <Text my={14} sizeVariant="md">
          {t("out_of_scope.list.header")}
        </Text>

        <ul className={classes.list}>
          <li>
            <Text sizeVariant="md">{t("out_of_scope.list.vehicleModel")}</Text>
          </li>
          <li>
            <Text sizeVariant="md">{t("out_of_scope.list.photoQuality")}</Text>
          </li>
        </ul>

        <Text my={14} sizeVariant="md">
          {t("out_of_scope.instruction")}
        </Text>

        {contactButton && (
          <ContactButton contactMethod={contactButton.type as ContactButtonMethod} url={contactButton.url}>
            <ClientTranslation i18nKey="estimate.contact_button">{{ client }}</ClientTranslation>
          </ContactButton>
        )}
      </Flex>
    </PageLayout>
  );
};
